import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay/legacy';
import { Link } from 'dibs-elements/exports/Link';

// components
import { FormattedMessage } from 'dibs-react-intl';
import Gallery from 'dibs-icons/exports/Gallery';
import { SharedContactDealerWrapper } from '../../contactDealer/SharedContactDealerWrapper';

// styles
import styles from './PdpRespHeroCarouselRequestMoreImages.scss';

export const PdpRespHeroCarouselRequestMoreImagesComponent = props => {
    const { item, user = {}, disableRequestMoreImagesModal, currency } = props;
    const contactSellerLink = onClick => (
        <Link className={styles.link} onClick={onClick}>
            <FormattedMessage
                id="PdpRespHeroCarouselRequestMoreImages.contactSeller"
                defaultMessage="Contact Seller"
            />
        </Link>
    );

    return (
        <div className={styles.container}>
            <Gallery className={styles.icon} />
            <div className={styles.header}>
                <FormattedMessage
                    id="PdpRespHeroCarouselRequestMoreImages.requestMoreMediaHeader"
                    defaultMessage="Want more images or videos?"
                />
            </div>
            <div className={styles.subheader}>
                <FormattedMessage
                    id="PdpRespHeroCarouselRequestMoreImages.requestMoreMediaSubheader"
                    defaultMessage="Request additional images or videos from the seller"
                />
            </div>
            {disableRequestMoreImagesModal ? (
                contactSellerLink()
            ) : (
                <SharedContactDealerWrapper
                    item={item}
                    user={user}
                    launchOrigin="pdp image carousel"
                    modalType="REQUEST_IMAGES"
                    currency={currency}
                >
                    {onClick => contactSellerLink(onClick)}
                </SharedContactDealerWrapper>
            )}
        </div>
    );
};

PdpRespHeroCarouselRequestMoreImagesComponent.defaultProps = {
    disableRequestMoreImagesModal: false,
};

PdpRespHeroCarouselRequestMoreImagesComponent.propTypes = {
    disableRequestMoreImagesModal: PropTypes.bool.isRequired,
    item: PropTypes.object,
    user: PropTypes.object,
    relay: PropTypes.object.isRequired,
    currency: PropTypes.string.isRequired,
};

export const PdpRespHeroCarouselRequestMoreImages = createFragmentContainer(
    PdpRespHeroCarouselRequestMoreImagesComponent,
    {
        item: graphql`
            fragment PdpRespHeroCarouselRequestMoreImages_item on Item {
                ...SharedContactDealerWrapper_item
                serviceId
            }
        `,
        user: graphql`
            fragment PdpRespHeroCarouselRequestMoreImages_user on User {
                ...SharedContactDealerWrapper_user
                serviceId
            }
        `,
    }
);
